import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IShowAdminFeesResponse } from '../types';
import {
  AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS,
  AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_API_URL,
  AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_QUERY_KEY,
} from '../constants';

export default function useShowAdminFeesQuery(date: Ref<string | undefined>): IContextQueryResult<IShowAdminFeesResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IShowAdminFeesResponse>({
    queryKey: [AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_QUERY_KEY, date],
    queryFn: ({ signal }) => fetchGet<IShowAdminFeesResponse>(
      AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_API_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.SHOW,
        queryParams: {
          'history_of_admin_fees_change[date]': date.value,
        },
      },
    ),
    enabled: computed(() => !!date.value),
  });
}
